import React, { useContext, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Fade } from "react-awesome-reveal";
import "swiper/css";
import { LinkContext } from "../../LinkProvider";

import SectionTitle from "../home/SectionTitle";
import SliderLine from "../home/SliderLine";

const CARDS = [
  { titleKey: "securityPage.money.card1.title", textKey: "securityPage.money.card1.text" },
  { titleKey: "securityPage.money.card2.title", textKey: "securityPage.money.card2.text" },
  { titleKey: "securityPage.money.card3.title", textKey: "securityPage.money.card3.text" },
  { titleKey: "securityPage.money.card4.title", textKey: "securityPage.money.card4.text" },
];

const BTN_GRADIENT_WHITE =
  "linear-gradient(-84deg, rgba(255,255,255,0.4) 6%, rgba(204,222,255,0.4) 66%)";

function FlowCard({ card, t }) {
  return (
    <Fade triggerOnce direction="up" duration={600}>
      <div className="relative overflow-hidden bg-[#294771] border border-[rgba(255,255,255,0.08)] rounded-[20px] min-h-[137px] lg:min-h-[148px] p-[24px] lg:p-[32px] flex flex-col gap-[12px]">
        <div className="absolute left-0 top-0 bottom-0 w-[4px] bg-[#4da6ff]" />
        <p className="font-['Inter'] font-bold text-[16px] lg:text-[20px] leading-[1.2] text-white">
          {t(card.titleKey)}
        </p>
        <p className="font-16-14-dark">{t(card.textKey)}</p>
      </div>
    </Fade>
  );
}

function MoneyFlow() {
  const { t } = useTranslation();
  const { link } = useContext(LinkContext);
  const swiperRef = useRef(null);
  const [current, setCurrent] = useState(0);

  return (
    <section className="mt bg-[#1c385f] py-[50px] lg:py-[75px]">
      <div className="glcontainer">
        <div className="flex flex-col lg:flex-row gap-[25px] lg:gap-[46px]">
          {/* Слева: заголовок + кнопка */}
          <div className="lg:w-[373px] shrink-0 flex flex-col">
            <SectionTitle
              title1={t("securityPage.money.title1")}
              title2={t("securityPage.money.title2")}
              text={t("securityPage.money.subtitle")}
              align="left"
              dark
            />
            <a
              href={link}
              className="hidden lg:inline-flex mt-auto w-fit items-center justify-center px-[42px] py-[18px] rounded-[40px] border border-white font-['Inter'] font-bold text-[16px] text-white capitalize backdrop-blur-[15px] hover:opacity-90 transition-opacity"
              style={{ backgroundImage: BTN_GRADIENT_WHITE }}
            >
              {t("securityPage.money.cta")}
            </a>
          </div>

          {/* Справа: 2x2 карточки (desktop) */}
          <div className="hidden lg:grid flex-1 grid-cols-2 gap-x-[15px] gap-y-[15px]">
            {CARDS.map((card) => (
              <FlowCard key={card.titleKey} card={card} t={t} />
            ))}
          </div>

          {/* Мобильный слайдер */}
          <div className="lg:hidden w-full">
            <Swiper
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              onSlideChange={(swiper) => setCurrent(swiper.realIndex)}
              spaceBetween={16}
              slidesPerView={1}
              grabCursor
              breakpoints={{ 640: { slidesPerView: 2.15, spaceBetween: 20 } }}
            >
              {CARDS.map((card) => (
                <SwiperSlide key={card.titleKey}>
                  <FlowCard card={card} t={t} />
                </SwiperSlide>
              ))}
            </Swiper>
            <SliderLine
              current={current}
              total={CARDS.length}
              onPrev={() => swiperRef.current?.slidePrev()}
              onNext={() => swiperRef.current?.slideNext()}
              dark
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default MoneyFlow;
